function teaserSwitcher() {
  
    // Get all link elements with class starting with "link-"
    const links = document.querySelectorAll('[class^="link-"]');

    // Get the default (first) link and image
    const defaultLink = document.querySelector('.link-1');
    const defaultImage = document.querySelector('.image-1');

    // Set default states for the first link's image
    if (defaultImage) {
        defaultImage.classList.add('opacity-100');
        defaultImage.classList.remove('opacity-0');
    }

    links.forEach((link, index) => {
        // Get the corresponding image element based on the link's index
        const image = document.querySelector(`.image-${index + 1}`);

        if (image) {
            // Add hover event listener to the link
            link.addEventListener('mouseover', function() {
                // If it's not the first link, revert the background of the first link and hide the default image
                if (index !== 0) {
                    if (defaultLink) {
                        defaultLink.classList.remove('bg-yellow');
                    }
                    if (defaultImage) {
                        defaultImage.classList.add('opacity-0');
                        defaultImage.classList.remove('opacity-100');
                    }
                }

                image.classList.add('opacity-100');
                image.classList.remove('opacity-0');
            });

            // When the mouse leaves the link, hide the current image and show the default image
            link.addEventListener('mouseout', function() {
                image.classList.remove('opacity-100');
                image.classList.add('opacity-0');

                if (defaultImage) {
                    defaultImage.classList.add('opacity-100');
                    defaultImage.classList.remove('opacity-0');
                }
            });
        }
    });

}

export default teaserSwitcher;